export default "__VITE_ASSET__C0NKY0Hx__"